module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', [_c('div', [_vm._v(_vm._s(_vm.moduleName))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.diamReference) + " "), (_vm.clientReference) ? _c('strong', [_vm._v(_vm._s(_vm.clientReference))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": ("/module/" + (_vm.module && _vm.module.id))
    }
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('OutlineButton', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('OutlineButton', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14f978a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_module/edit-module-header.vue
// module id = 3030
// module chunks = 0